import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'
import { SIZE } from '../../../../../../constants/size'
import { FormModal } from '../../../../../Form'

import { CustomizeRecipientAudienceFormFields } from './CustomizeRecipientAudienceFormFields'
import {
  QA_NAME_CUSTOMIZE_RECIPIENT_MODAL,
  RECIPIENT_AUDIENCE_INFO_NOTIFICATION,
} from './CustomizeRecipientAudienceModal.constants'

function CustomizeRecipientAudienceModal({
  initialValues,
  isStaffUserAcc,
  ticker,
  validationSchema,
  onCloseModal,
  onSubmit,
}) {
  const { t } = useTranslation()

  const initialNotifications = [
    {
      id: RECIPIENT_AUDIENCE_INFO_NOTIFICATION,
      text: t('Newsboard.MessageWillAlsoSentAsEmailNotificationKey'),
      type: NOTIFICATION_TYPE.info,
    },
  ]

  return (
    <FormModal
      Fields={CustomizeRecipientAudienceFormFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_CUSTOMIZE_RECIPIENT_MODAL,
      }}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{ isStaffUserAcc, ticker }}
      formTitle='Newsboard.AddRecipientModalTitleKey'
      initialNotifications={initialNotifications}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onCloseModal}
      onSubmit={onSubmit}
    />
  )
}

export default CustomizeRecipientAudienceModal
